export const studentRestriction = [
    { label: 'Allow access on only mobile app', value: 1 },
    { label: 'Allow access on both web and mobile app', value: 0 },
]
